import { applyMaskAmount } from "./utils";

export const checkComplianceOutStatus = (asset, allAssetsOut) => {

  const {
    allAssetsOuts13,
    allAssetsOuts14,
    allAssetsOuts18,
    allAssetsOuts19,
    allAssetsOutsTargets,
    allAssetsOutsLimitResolution
  } = allAssetsOut;

  const outs = [];
  if (allAssetsOuts13.find(el => el.id === asset.id)) {
    outs.push("Desenquadramento no artigo 13");
  }
  if (allAssetsOuts14.find(el => el.id === asset.id)) {
    outs.push("Desenquadramento no artigo 14");
  }
  if (allAssetsOuts18.find(el => el.id === asset.id)) {
    outs.push("Desenquadramento no artigo 18");
  }
  if (allAssetsOuts19.find(el => el.id === asset.id)) {
    outs.push("Desenquadramento no artigo 19");
  }
  if (allAssetsOutsTargets.find(el => el.id === asset.id)) {
    outs.push("Desenquadramento na política de investimentos");
  }
  if (allAssetsOutsLimitResolution.find(el => el.id === asset.id)) {
    outs.push("Desenquadramento nos limites de resolução");
  }

  return outs;
};

export const checkComplianceAlmostOutStatus = (asset, allAssetsOut) => {

  const {
    mapAlmostOutsTargets
  } = allAssetsOut;

  // console.log("mapAlmostOutsTargets ", mapAlmostOutsTargets);

  const outs = [];
  if (mapAlmostOutsTargets[asset.article_id]) {

    // console.log("Asset quase out: ", asset);
    //console.log("mapAlmostOutsTargets[asset.article_id]: ", mapAlmostOutsTargets[asset.article_id])
    outs.push(`Em rota de desenquadramento na política de investimentos: ${applyMaskAmount(mapAlmostOutsTargets[asset.article_id].percentInPortfolio)}%`);
  }

  return outs;
};

//Indexa os desenquadramentos do catálogo da 5.272 pelo ativo a que pertencem.
//A chave é o fundo; ativos sem fund_id (títulos) recaem no CNPJ
const buildAssetKey = (fundId, cnpj) => fundId ? 'fund_' + fundId : 'cnpj_' + cnpj;

export const buildRulesComplianceIndex = (violations) => {

  const index = {};

  (violations || []).forEach(violation => {

    //Regras apuradas sobre um conjunto de fundos, como a concentração por gestora, marcam
    //todos os ativos que entraram na conta; as demais marcam o próprio ativo da violação
    const targets = violation.assets && violation.assets.length ?
      violation.assets
      : [{ fund_id: violation.fund_id, cnpj: violation.cnpj }];

    targets.forEach(target => {

      //A violação por gestora não tem fundo nem CNPJ próprios, e sem esta guarda todo ativo
      //sem identificação cairia na mesma chave
      if (!target.fund_id && !target.cnpj) {
        return;
      }

      const key = buildAssetKey(target.fund_id, target.cnpj);

      if (!index[key]) {
        index[key] = [];
      }

      index[key].push(violation);

    });

  });

  return index;
};

//Status de desenquadramento de um ativo no fluxo de regras da 5.272.
//Diferente de checkComplianceOutStatus, a mensagem cita a regra que foi violada,
//o percentual apurado e o limite, porque tudo isso já vem do backend
export const checkRulesComplianceOutStatus = (asset, rulesCompliance) => {

  if (!rulesCompliance || !rulesCompliance.index) return [];

  const violations = rulesCompliance.index[buildAssetKey(asset.fund_id, asset.cnpj)];

  if (!violations) return [];

  return violations.map(violation => {

    //A regra de elegibilidade não tem percentual a citar: sem este ramo a linha sairia
    //"NaN% (limite null%)"
    if (violation.rule_basis == RULE_BASIS.ELIGIBILITY) {
      return `${violation.rule_code} · ${violation.rule_name}: nem o gestor nem o `
        + 'administrador estão classificados nos segmentos S1 ou S2';
    }

    return `${violation.rule_code} · ${violation.rule_name}: ${applyMaskAmount(violation.percent)}% `
      + `(limite ${violation.rule_limit}%)`
      //Na concentração por gestora o percentual não é do ativo, e sim do conjunto; na R10 ele é
      //do administrador. Sem dizer de quem é, a mensagem na linha do fundo fica sem sentido
      + (violation.manager_name ? ` — ${violation.manager_name}`
        : (violation.administrator && violation.administrator.name ?
          ` — ${violation.administrator.name}` : ''));

  });
};

export const getComplianceDetails = (asset, complianceData) => {
  if (!complianceData || !complianceData.articles) return null;

  const article = complianceData.articles.find(art =>
    art.device_abbreviation === asset.device_abbreviation
  );

  if (!article) return null;

  return {
    device: article.device,
    limit: article.limit_resolution,
    current: asset.participation,
    description: article.description,
    segment_name: article.segment_name
  };
};

//Base de cálculo de cada regra, espelhando RULE_BASIS do motor. A apresentação decide por
//aqui quais colunas a tabela tem — a regra de elegibilidade não mede proporção e por isso não
//tem percentual, limite nem folga a mostrar
export const RULE_BASIS = {
  PORTFOLIO: 'portfolio',
  FUND_PL: 'fundPl',
  MANAGER_TOTAL: 'managerTotal',
  ELIGIBILITY: 'eligibility',
  ENTITY_RPPS_SHARE: 'entityRppsShare',
};

//Veredito de uma regra da 5.272 depois de apurada a carteira. Espelha o RULE_STATUS do motor
//(src/controllers/utils/resolution_5272_rules.js): o backend devolve o código e a tela escolhe a
//frase, que é a mesma divisão de trabalho já adotada para as pendências
export const RULE_STATUS = {
  OUT: 'out',
  COMPLIANT: 'compliant',
  PARTIAL: 'partial',
  NOT_APPLICABLE: 'not_applicable',
  NOT_EVALUATED: 'not_evaluated',
};

//Como cada estado se apresenta. O rótulo é curto porque acompanha o cabeçalho da regra
export const RULE_STATUS_PRESENTATION = {
  [RULE_STATUS.OUT]: { label: 'Desenquadrada', tone: 'error' },
  [RULE_STATUS.COMPLIANT]: { label: 'Contemplada', tone: 'success' },
  [RULE_STATUS.PARTIAL]: { label: 'Parcialmente apurada', tone: 'warning' },
  [RULE_STATUS.NOT_APPLICABLE]: { label: 'Não aplicável', tone: 'neutral' },
  [RULE_STATUS.NOT_EVALUATED]: { label: 'Não avaliada', tone: 'warning' },
};

//Concordância do rótulo que vem do catálogo: "1 gestora apurada", "2 ativos apurados"
const SUBJECT_WORDS = {
  'Ativo': { one: 'ativo apurado', many: 'ativos apurados', none: 'Nenhum ativo' },
  'Gestora': { one: 'gestora apurada', many: 'gestoras apuradas', none: 'Nenhuma gestora' },
  'Emissor': { one: 'emissor apurado', many: 'emissores apurados', none: 'Nenhum emissor' },
};

const getSubjectWords = (rule) => {
  const subject = rule && rule.subject ? rule.subject : 'Ativo';
  return SUBJECT_WORDS[subject] ? SUBJECT_WORDS[subject] : SUBJECT_WORDS['Ativo'];
};

export const getRuleStatus = (group) =>
  group && group.summary && group.summary.status ?
    group.summary.status : RULE_STATUS.NOT_EVALUATED;

//Quadro das regras na ordem do catálogo, com a contagem por estado. O botão do header e o painel
//leem daqui, para não contarem coisas diferentes e dizerem uma o contrário da outra
export const buildRulesOverview = (byCode) => {

  const groups = Object.values(byCode || {});

  const counts = {
    total: groups.length,
    [RULE_STATUS.OUT]: 0,
    [RULE_STATUS.COMPLIANT]: 0,
    [RULE_STATUS.PARTIAL]: 0,
    [RULE_STATUS.NOT_APPLICABLE]: 0,
    [RULE_STATUS.NOT_EVALUATED]: 0,
  };

  groups.forEach(group => {

    const status = getRuleStatus(group);

    if (counts[status] !== undefined) {
      counts[status]++;
    }

  });

  return { groups, counts };
};

//A frase que resume a apuração de uma regra. Fica aqui, e não no JSX, porque precisa ser
//conferível sem montar a tela — e porque a mesma redação serve ao tooltip do header
export const getRuleSummaryNote = (group) => {

  if (!group || !group.summary) return '';

  const { rule, summary } = group;
  const words = getSubjectWords(rule);

  if (summary.status == RULE_STATUS.NOT_EVALUATED) {
    return 'Esta regra não pôde ser apurada nesta carteira.';
  }

  if (summary.status == RULE_STATUS.NOT_APPLICABLE) {
    return words.none + ' da carteira é alcançado por esta regra.';
  }

  const parts = [];

  parts.push(summary.evaluated_count
    + ' ' + (summary.evaluated_count == 1 ? words.one : words.many));

  //Na regra de elegibilidade não há "maior apurado" nem "menor folga": o que informa é quantos
  //cumprem a condição
  if (rule && rule.basis == RULE_BASIS.ELIGIBILITY) {

    parts.push(summary.compliant_count + ' com gestor ou administrador S1/S2');

    if (summary.violated_count) {
      parts.push(summary.violated_count + ' sem nenhum dos dois');
    }

    return parts.join(' · ');
  }

  //O caso mais próximo do limite é o que interessa a quem acompanha a carteira
  if (summary.max_percent !== null && summary.max_percent !== undefined) {
    parts.push('maior apurado ' + applyMaskAmount(summary.max_percent) + '%'
      + (summary.max_percent_subject ? ' — ' + summary.max_percent_subject : ''));
  }

  if (summary.min_headroom !== null && summary.min_headroom !== undefined) {
    parts.push('menor folga ' + applyMaskAmount(summary.min_headroom) + ' p.p.');
  }

  return parts.join(' · ');
};

//O que a regra deixou de apurar. Dito por saldo, que é exato em toda natureza de pendência,
//enquanto a contagem mistura fundo com gestora conforme o motivo
export const getRuleSkippedNote = (group) => {

  if (!group || !group.summary || !group.summary.skipped_count) return '';

  const { rule, summary } = group;

  if (rule && rule.basis == RULE_BASIS.ELIGIBILITY) {
    return applyMaskAmount(summary.skipped_balance, true)
      + ' sem instituição vinculada ao gestor ou ao administrador — a regra foi apurada só em parte.';
  }

  if (rule && rule.basis == RULE_BASIS.ENTITY_RPPS_SHARE) {
    return applyMaskAmount(summary.skipped_balance, true)
      + ' em fundos cujo administrador não foi encontrado no arquivo da ANBIMA'
      + ' — a regra foi apurada só em parte.';
  }

  return applyMaskAmount(summary.skipped_balance, true) + ' sem base para o cálculo'
    + ' — a regra foi apurada só em parte.';
};
